export const skillGroupMaker = (skills = [], people = [], activePerson = {}, name = '', fundamentals = []) => ({
    skills,
    people,
    activePerson,
    name,
    fundamentals,
});
